
import RecommendationSection from '@recommendation/components/RecommendationSection/RecommendationSection.vue'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import translations from './RecommendationCrossSell.translations'

export default {
  components: {
    RecommendationSection,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    trackingList: () => PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL,
    scopeId() {
      return String(this.listingId)
    },
  },
}
